import { Box, IconButton, Slider, Tooltip } from "@mui/material";
import zoomOutHorizontal from "../../svg/zoomOutHorizontal.svg";
import zoomInHorizontal from "../../svg/zoomInHorizontal.svg";

export const DAWZoomSlider = ({ onChange, value = 0 }) => {
  const MAX_ZOOM_VALUE = 100;

  const increaseZoom = () => {
    let newValue = value + 5;
    if (newValue > MAX_ZOOM_VALUE) newValue = MAX_ZOOM_VALUE;
    onChange(newValue);
  };

  const decreaseZoom = () => {
    let newValue = value - 5;
    if (newValue < 0) newValue = 0;
    onChange(newValue);
  };

  const handleChange = (v) => {
    if (v && v.target) {
      const newValue = v.target.value;
      onChange(newValue);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1} width={1}>
      <Tooltip title="Decrease Zoom">
        <IconButton onClick={decreaseZoom}>
          <img src={zoomOutHorizontal} height={24} width={24} alt="zoom out" />
        </IconButton>
      </Tooltip>
      <Slider
        aria-label="Zoom"
        defaultValue={0}
        max={MAX_ZOOM_VALUE}
        size="small"
        step={1}
        value={value}
        onChange={handleChange}
      />
      <Tooltip title="Increase Zoom">
        <IconButton onClick={increaseZoom}>
          <img src={zoomInHorizontal} height={24} width={24} alt="zoom in" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
